import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "dashboards-calendar__header" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VesCalendarLegend = _resolveComponent("VesCalendarLegend")!
  const _component_Tooltip = _resolveComponent("Tooltip")!
  const _component_VesCalendar = _resolveComponent("VesCalendar")!
  const _component_IndicatorCard = _resolveComponent("IndicatorCard")!

  return (_openBlock(), _createBlock(_component_IndicatorCard, {
    mod: "inverted-card",
    class: "dashboards-calendar"
  }, {
    values: _withCtx(() => [
      _createElementVNode("header", _hoisted_1, [
        _cache[0] || (_cache[0] = _createElementVNode("h2", { class: "dashboards-calendar__title" }, "График мероприятий", -1)),
        (_ctx.isDense)
          ? (_openBlock(), _createBlock(_component_Tooltip, {
              key: 0,
              modContent: "width-360",
              class: "tooltip-component--mobile-big"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_VesCalendarLegend)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _createVNode(_component_VesCalendar, {
        isDense: _ctx.isDense,
        params: _ctx.params,
        dateNavigation: _ctx.dateNavigation
      }, null, 8, ["isDense", "params", "dateNavigation"])
    ]),
    _: 1
  }))
}